import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Adal8Service } from 'adal-angular8';
import { Observable, of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { ConstantsService } from '../services/constants.service';
import { BaseService } from './base.service';

@Injectable()
export class DataService {

  constructor(private baseService: BaseService, private adal4Service: Adal8Service, private httpClient: HttpClient) { }

  /**
* Handle Http operation that failed.
* @param operation - name of the operation that failed
* @param result - optional value to return as the observable result
*/
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<any> => {
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
      // TODO: better job of transforming error for user consumption
      console.log(`${operation} failed: ${error.message}`);
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  /**
  * Sends Http Post request to server
  * @param _this - this object
  * @param url - Url of API
  * @param data - optional data to be sent to server
  * @param token - Access token for resource API
  */
  private getApiResponse(_this, url, data, token) {

    const httpOptions = {
      headers: null
    };
    const contractorLoginResponse = this.baseService.getItemFromSession(ConstantsService.ContractorLoginResponse);
    let contractorEmail = '';

    const employeeLoginResponse = this.baseService.getItemFromSession(ConstantsService.EmployeeLoginResponse);
    let employeeEmail = '';

    if (contractorLoginResponse) {
      contractorEmail = JSON.parse(contractorLoginResponse).Email;
    }

    if (employeeLoginResponse) {
      employeeEmail = JSON.parse(employeeLoginResponse).Email;
    }
    if (httpOptions.headers == null) {
      httpOptions.headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'X-Adal-User': (_this.adal4Service.userInfo.profile === undefined) ? '' : (_this.adal4Service.userInfo.profile.upn),
        'Contractor-User': (contractorEmail !== '') ? contractorEmail : employeeEmail,
        'X-Timezone-Offset': this.getTimezone() 
        
      });
      //  
      // //if(url.toString().includes('getDocumentDetails'))
      // {
      // httpOptions.headers.append("Access-Control-Allow-Headers", "Content-Type");
      // // httpOptions.headers.append("Content-Type", "application/json");
      // httpOptions.headers.append("Accept", "application/json");
      // httpOptions.headers.append("Access-Control-Allow-Methods", "OPTIONS,POST,GET");
      // httpOptions.headers.append("Access-Control-Allow-Origin", "*");
      // httpOptions.headers.append("Access-Control-Allow-Origin", "https://arauathsestorage.blob.core.windows.net")
      // httpOptions.headers.append('Access-Control-Allow-Credentials', 'true');
      // httpOptions.headers.append('Origin','*');
      // }
       
    }
    return _this.httpClient.post(url, data, httpOptions)
      .pipe(
        catchError(_this.handleError('getApiResponse'))
      );
  }


  /**
      * Sends Http Post request to server
      * @param url - Url of API
      * @param data - optional data to be sent to server
      */
  post(url, data = null): Observable<any> {
    const _this = this;
    let resource;
    url = ConstantsService.URL.API + url;
    resource = this.baseService.getResourceForEndpoint(url);
    if (resource) {
      // If logged in user is employee then adal4 token else db token
      const loggedinUserType = this.baseService.getItemFromSession(ConstantsService.LoggedInUserType);
      const employeeLoginResponse = this.baseService.getItemFromSession(ConstantsService.EmployeeLoginResponse);
      const contractorLoginResponse = this.baseService.getItemFromSession(ConstantsService.ContractorLoginResponse);
      if (loggedinUserType === ConstantsService.authenticationType.Employee && employeeLoginResponse !== null) {
        return _this.getApiResponse(_this, url, data, 'Contractor:' + JSON.parse(employeeLoginResponse).UserToken);
      } else if (loggedinUserType === ConstantsService.authenticationType.Contractor && contractorLoginResponse !== null) {
        return _this.getApiResponse(_this, url, data, 'Contractor:' + JSON.parse(contractorLoginResponse).UserToken);
      }
      else {
        return this.getApiResponse(this, url, data, 'Anonymous');
      }
    } else {
      return this.getApiResponse(this, url, data, 'Anonymous');
    }
  }

  /**
      * Sends Http Post request to server
      * @param url - Url of API
      * @param data - optional data to be sent to server
      */
  postHttpResponse(url, data = null): Observable<any> {
    const _this = this;
    let resource;
    url = ConstantsService.URL.API + url;
    resource = this.baseService.getResourceForEndpoint(url);
    if (resource) {
      // If logged in user is employee then adal4 token else db token
      const employeeLoginResponse = this.baseService.getItemFromSession(ConstantsService.EmployeeLoginResponse);
      const contractorLoginResponse = this.baseService.getItemFromSession(ConstantsService.ContractorLoginResponse);
      const loggedinUserType = this.baseService.getItemFromSession(ConstantsService.LoggedInUserType);
      if (loggedinUserType === ConstantsService.authenticationType.Employee && employeeLoginResponse !== null) {
        return _this.getHttpResponse(_this, url, data, 'Contractor:' + JSON.parse(employeeLoginResponse).UserToken);
      } else if (loggedinUserType === ConstantsService.authenticationType.Contractor && contractorLoginResponse !== null) {
        return _this.getHttpResponse(_this, url, data, 'Contractor:' + JSON.parse(contractorLoginResponse).UserToken);
      }
      else {
        return this.getHttpResponse(this, url, data, 'Anonymous');
      }
    } else {
      return this.getHttpResponse(this, url, data, 'Anonymous');
    }
  }

  private getHttpResponse(_this, url, data, token) {

    const httpOptions = {
      headers: null,
      responseType: 'arraybuffer'
    };
    const contractorLoginResponse = this.baseService.getItemFromSession(ConstantsService.ContractorLoginResponse);
    let contractorEmail = '';

    if (contractorLoginResponse) {
      contractorEmail = JSON.parse(contractorLoginResponse).Email;
    }

    const employeeLoginResponse = this.baseService.getItemFromSession(ConstantsService.EmployeeLoginResponse);
    let employeeEmail = '';

    if (employeeLoginResponse) {
      employeeEmail = JSON.parse(employeeLoginResponse).Email;
    }

    if (httpOptions.headers == null) {
      httpOptions.headers = new HttpHeaders({
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + token,
        'X-Adal-User': (_this.adal4Service.userInfo.profile === undefined) ? '' : (_this.adal4Service.userInfo.profile.upn),
        'Contractor-User': (contractorEmail !== '') ? contractorEmail : employeeEmail,
        'X-Timezone-Offset': this.getTimezone()
      });
    }

    return _this.httpClient.post(url, data, httpOptions)
      .pipe(
        catchError(_this.handleError('getApiResponse'))
      );
  }
  private getTimezone() : string {
		return( String( Intl.DateTimeFormat().resolvedOptions().timeZone ) );
	}
}
